import {Box} from 'src/design/atoms/Box';
import {Image} from 'src/design/atoms/Image';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
export interface FormViewDrawingPadV2Props {
  field: IFormFieldV2;
  value: string;
}

export const FormViewDrawingPadV2: React.FC<FormViewDrawingPadV2Props> = ({
  field,
  value,
}) => {
  return (
    <Box data-testid={`form-view-${field.name}`}>
      <Text fw={500} size="sm" c="dimmed" mb="xs">
        {field.label}
      </Text>
      {value && <Image maw={700} mah={500} src={value} alt="Drawing" />}
    </Box>
  );
};
